module.exports = __webpack_public_path__ + "static/media/Moore Communications Group Logo.03f5b6db.png";